import { isPromoFn } from '../../../../shared';
import { useBondsBondTransformApi } from '../api';

export const useBondsBondIsPromo = () => {
  const response = useBondsBondTransformApi(isPromoFn);
  return response;
};
